export const selectOrderInfo = (state) => state.orders.orderInfo;
export const selectOrderStatus = (state) => state.orders.orderStatus;
export const selectPastOrderDetails = (state) => state.orders.pastOrderDetails;
export const selectOrderType = (state) => state.orders.orderType;
export const selectOrderSchedule = (state) => state.orders.schedule;
export const selectOrderComments = (state) => state.orders.comments;
